/**
 * UMD-only entry.
 *
 * When consumed via `<script src="...sdk.js">`, Rollup wraps the bundle
 * in a UMD envelope and assigns the module's default export to
 * `window.Vibecade`. By default-exporting the Vibecade class here (and
 * using `output.exports: 'default'` in vite.config.umd.ts), that global
 * ends up being the class itself — so script-tag consumers can do
 * `new Vibecade(...)` directly.
 *
 * VibecadeError / VibecadeErrorCode are attached as statics so UMD
 * consumers can still reach them via `Vibecade.Error` /
 * `Vibecade.ErrorCode`.
 */
import { Vibecade as VibecadeClass } from './client';
import { VibecadeError, VibecadeErrorCode } from './types';

type Augmented = typeof VibecadeClass & {
  Error: typeof VibecadeError;
  ErrorCode: typeof VibecadeErrorCode;
};

const Augmented = VibecadeClass as Augmented;
Augmented.Error = VibecadeError;
Augmented.ErrorCode = VibecadeErrorCode;

export default Augmented;
